export default "__VITE_ASSET__Bf2oUP28__"